/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { getAccessToken } from "@lib/shared/cookies";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig, AxiosError } from "axios";
import { ServerRequest } from "@lib/shared/types";
import { DomainPostItemType } from "pages/api/fetchDomainPosts";
import { buildQueryParams } from "@lib/serverUtils";

export interface DomainPostsResponse {
    success: boolean;
    data: DomainPostItemType[];
    totalCount?: number;
}

export interface GetDomainPostsParams {
    type?: string;
    taxonomySlug?: string[];
    limit?: string;
    page?: number;
    offset?: number;
    "filter[id]"?: string;
    "filter[featured]"?: boolean;
}

export const getDomainPosts = async (
    params: GetDomainPostsParams,
    req?: ServerRequest,
): Promise<{
    data: DomainPostItemType[] | null;
    error: AxiosError | null;
    totalCount: number;
}> => {
    const isServer = !!req;

    const accessToken = isServer
        ? (req.accessToken as string)
        : (getAccessToken() as string);

    const queryParams = buildQueryParams(params);

    const config: AxiosRequestConfig = isServer
        ? {
              method: "get",
              url: `/api/web/v1/domains/posts/?${queryParams}`,
              headers: {
                  Authorization: `Bearer ${accessToken}`,
                  "X-DOMAIN-NAME": `${req.headers.host ?? ""}`,
                  "X-Language": `${req.locale ?? "en"}`,
              },
          }
        : {
              method: "get",
              url: `/api/fetchDomainPosts?${queryParams}`,
              headers: {
                  Authorization: `Bearer ${accessToken ?? ""}`,
              },
          };

    const {
        data: postsResponse,
        error,
        response,
    } = await apiHandler<DomainPostsResponse>(() =>
        isServer ? HTTP.server(config) : HTTP.client(config),
    );

    // Get totalCount from x-total-count header
    const totalCountFromHeader = response?.headers?.["x-total-count"];

    const totalCount = totalCountFromHeader
        ? parseInt(String(totalCountFromHeader), 10)
        : 0;

    return {
        data: postsResponse?.data ?? null,
        error,
        totalCount,
    };
};
